<template>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
        <v-card>
            <v-toolbar color="primary" title="Fechamento de Balanço">
                <v-btn color="black" @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <FormCashierBalance :user="user"
                                    :cashier="cashier"
                                    @cashier:closed="dialog = false" />
            </v-card-text>
            <v-card-actions class="justify-end">
                <v-btn variant="text" color="error" @click="dialog = false">
                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import FormCashierBalance from "./FormCashierBalance.vue";

export default {
    components: {
        FormCashierBalance
    },
    data() {
        return {
            dialog: false,
        }
    },
    emits: ['closed'],
    props: {
        user: Object,
        cashier: Object,
    },
    watch: {
        cashier: {
            handler(newVal) {
                const vm = this;

                if (!vm.dialog && newVal) {
                    vm.dialog = true;
                }
            },
            immediate: true
        },
        dialog(newVal, oldVal) {
            const vm = this;

            if (oldVal && !newVal) {
                vm.$emit('closed');
            }
        }
    }
}
</script>